import { render, staticRenderFns } from "./TheUserSettingsView.vue?vue&type=template&id=4d110e21&"
import script from "./TheUserSettingsView.vue?vue&type=script&lang=js&"
export * from "./TheUserSettingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
